import { pickGmwLibraryFields } from "../../../schema/gmw-schema-library";

import type { SourcedocumentDataSchemaFor } from "./_gmw-event-schema-collection";

export const gmwWellHeadProtectorSchema: SourcedocumentDataSchemaFor<"GMW_WellHeadProtector"> = {
  type: "object",
  title: "Gebeurtenis gegevens",
  required: ["eventDate", "wellHeadProtector"],
  properties: pickGmwLibraryFields(["eventDate", "wellHeadProtector"]),
};
